// @ts-check
import {
    nextArrowCustom,
    prevArrowCustom,
    defaultOptions,
} from "../global/slick-options";
import { getAll } from "../utilities/querySelector";

const cardSlider = getAll('[data-slider="card-slider"]');

if (cardSlider.length) {
    cardSlider.forEach((slider) => {
        const size = slider.getAttribute("data-card-slider-size");

        let options = {
            ...defaultOptions,
            nextArrow: nextArrowCustom(jQuery(slider)),
            prevArrow: prevArrowCustom(jQuery(slider)),
        };

        if (size == "small") {
            options = {
                ...options,
                slidesToShow: 4,
                responsive: [
                    {
                        breakpoint: 1250,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 850,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            };
        } else if (size == "medium") {
            options = {
                ...options,
                slidesToShow: 4,
                responsive: [
                    {
                        breakpoint: 1250,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 850,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            };
        } else if (size == "large") {
            options = {
                ...options,
                slidesToShow: 1.33,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            };
        } else if (size == "huge") {
            options = {
                ...options,
                slidesToShow: 1,
            };
        }

        jQuery(slider).slick({
            ...options,
        });
    });
}
